import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function CancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7 0 10 16",
    height: "16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.96 11.03L10.99 8 7.96 4.97l1.01-1.01L12 6.99l3.03-3.03 1.01 1.01L13.01 8l3.03 3.03-1.01 1.01L12 9.01l-3.03 3.03z",
    fill: "currentColor"
  }));
}
export default CancelIcon;
//# sourceMappingURL=CancelIcon.js.map